export const PrivacyPolicy = () => {
  return (
    <>
      <h2 class="font-secondary-sans font-bold uppercase text-[33px] leading-8 pb-[20px]">
        EYEJACK PRIVACY POLICY
      </h2>
      <p class="font-inter-light leading-[22px]">
        EYEJACK PTY LTD ABN 80 615 617 135 (“EyeJack”, “we”, “us”) is bound by
        the Australian Privacy Principles (“APPs”) set out in the Privacy Act
        1988 (Cth) (“Act”). We are committed to complying with the Act and, to
        the extent applicable, the European Union (“EU”) General Data Protection
        Regulation (“GDPR”), if we process personal data relating to
        identifiable EU residents, or the California Consumer Privacy Act
        (“CCPA”) if personally identifiable information of California residents
        is processed.
      </p>

      <p class="font-inter-light leading-[22px]">
        This Privacy Policy governs how we deal with your personal information,
        including via the EyeJack Creator Platform (“our Platform”), the EyeJack
        Creator desktop and mobile apps (collectively “our Apps”), and our
        online store (“Store”) via our website,{" "}
        <a href="https://eyejackapp.com">https://eyejackapp.com</a> (“Website”).
      </p>

      <p class="font-inter-light leading-[22px]">
        By providing your personal information to us, you consent to the
        collection, use, transfer and disclosure of your information under the
        terms of this Privacy Policy. This Privacy Policy is to be read in
        conjunction with the Terms of Use.
      </p>

      <h2 class="font-secondary-sans font-bold uppercase text-[33px] leading-8 pb-[20px]">
        SECTION 1. How we collect and use your information
      </h2>

      <p class="font-inter-light leading-[22px]">
        Personal information is collected when you knowingly and voluntarily
        submit it, either to us or as publicly displayed by you online.
      </p>

      <p class="font-inter-light leading-[22px]">
        In the course of providing our services, we collect personal information
        in a variety of ways. For example, information is collected when you:
      </p>

      <ul class="font-inter-light leading-[22px]">
        <li>Subscribe to our Platform;</li>
        <li>Purchase from our Store;</li>
        <li>Browse our Website;</li>
        <li>Download our Apps.</li>
      </ul>

      <p class="font-inter-light leading-[22px]">
        The kinds of personal information that we may collect, and hold
        includes:
      </p>

      <ul class="font-inter-light leading-[22px]">
        <li>
          Contact details including your name, phone number, billing address,
          shipping address and email address;
        </li>
        <li>Your computer’s internet protocol (IP) address;</li>
        <li>Your credit card and payment details.</li>
      </ul>

      <p class="font-inter-light leading-[22px]">
        We may use your personal information in the following ways:
      </p>

      <ul class="font-inter-light leading-[22px]">
        <li>To process and fulfil your order;</li>
        <li>To help us learn about your browser and operating system;</li>
        <li>
          Where you have opted in, to send you emails about our Store, products,
          exclusive offers and other updates;
        </li>
        <li>To deal with your enquiries and provide customer service.</li>
      </ul>

      <p class="font-inter-light leading-[22px]">
        We will not collect sensitive information about you (such as personal
        information about your health, race, political opinion etc.) without
        your specific consent or in the circumstances permitted by the Act.
      </p>

      <h2 class="font-secondary-sans font-bold uppercase text-[33px] leading-8 pb-[20px]">
        SECTION 2. Your consent
      </h2>

      <p class="font-inter-light leading-[22px]">How do you get my consent?</p>

      <p class="font-inter-light leading-[22px]">
        When you provide us with personal information to complete a transaction,
        verify your credit card, place an order, arrange for a delivery or
        return a purchase, your consent to our collecting and using your
        information is implied for that reason.
      </p>

      <h2 class="font-secondary-sans font-bold uppercase text-[33px] leading-8 pb-[20px]">
        SECTION 3. Disclosure
      </h2>

      <p class="font-inter-light leading-[22px]">
        When you place an order via our Store, EyeJack will need to disclose
        your personal information to companies who perform parts of our service
        delivery.
      </p>

      <h2 class="font-secondary-sans font-bold uppercase text-[33px] leading-8 pb-[20px]">
        SECTION 4. Shopify
      </h2>

      <p class="font-inter-light leading-[22px]">
        Our Store is hosted on Shopify Inc. (“Shopify”) that provide us with the
        online e-commerce platform that allows us to sell our products and
        services to you.
      </p>

      <h2 class="font-secondary-sans font-bold uppercase text-[33px] leading-8 pb-[20px]">
        SECTION 5. Third-party services
      </h2>

      <p class="font-inter-light leading-[22px]">
        In general, the third-party providers used by us will only collect, use
        and disclose your information to the extent necessary to allow them to
        perform the services they provide to us.
      </p>

      <h2 class="font-secondary-sans font-bold uppercase text-[33px] leading-8 pb-[20px]">
        SECTION 6. Security and storage
      </h2>

      <p class="font-inter-light leading-[22px]">
        To protect your personal information, we take reasonable precautions and
        follow industry best practices to make sure it is not inappropriately
        lost, misused, accessed, disclosed, altered or destroyed.
      </p>

      <h2 class="font-secondary-sans font-bold uppercase text-[33px] leading-8 pb-[20px]">
        SECTION 7. Cookies
      </h2>

      <p class="font-inter-light leading-[22px]">
        Depending on how you use our Website, we may store cookies on your
        computer in order to collect certain aggregate data about our users and
        to customize certain aspects of your specific user experience.
      </p>
    </>
  );
};
